import * as classnames from 'classnames'
import * as React from 'react'

import * as styles from './pageSection.module.css'

const PageSection = ({
  children,
  borderTop,
  darkBackground,
  spaceBottom,
  spaceTop,
  sectionId
}: {
  children: any
  borderTop?: boolean
  darkBackground?: boolean
  spaceBottom?: boolean
  spaceTop?: boolean
  sectionId?: string
}) => {
  const sectionClassName = classnames(styles.pageSection, {
    [styles.borderTop]: borderTop,
    [styles.darkBackground]: darkBackground,
    [styles.spaceBottom]: spaceBottom,
    [styles.spaceTop]: spaceTop
  })
  return (
    <section id={sectionId} className={sectionClassName}>
      <div className={styles.gridContainer}>{children}</div>
    </section>
  )
}

export default PageSection
